import { defineMessages, useIntl } from 'react-intl';
import { type MfaVerifyPageProps } from './MfaTypes';
import { MfaLayout } from './MfaLayout';
import { MfaCodeForm } from './MfaCodeForm';

const messages = defineMessages({
  headline: {
    id: 'mfaVerifyHeadline',
    defaultMessage: 'Multi-Factor Authentication'
  },
  codeLabel: {
    id: 'mfaVerifyCodeLabel',
    defaultMessage: 'Authenticator App One Time Password'
  },
  codePlaceholder: {
    id: 'mfaVerifyCodePlaceholder',
    defaultMessage: 'Enter your Authenticator App One Time Password'
  },
  verifyButton: {
    id: 'mfaVerifyButton',
    defaultMessage: 'Sign In'
  }
});

export const MfaVerifyPage = ({ communityName, hasLogo, logoUrl, error }: MfaVerifyPageProps) => {
  const intl = useIntl();

  return (
    <MfaLayout
      communityName={communityName}
      hasLogo={hasLogo}
      logoUrl={logoUrl}
      headline={messages.headline}
      error={error}
    >
      <MfaCodeForm
        codeLabel={intl.formatMessage(messages.codeLabel)}
        codePlaceholder={intl.formatMessage(messages.codePlaceholder)}
        buttonLabel={messages.verifyButton}
      />
    </MfaLayout>
  );
};
